import ApiService from "./api.service";

interface TripItinerary {
  lat: number;
  lng: number;
  i18n: {
    zhHK: {
      displayName: string;
      formattedAddress: string;
    };
    en: {
      displayName: string;
      formattedAddress: string;
    };
  };
  index: number;
  placeId: string;
}

interface PaymentInformation {
  cardNumber: string;
  paymentMethod: string;
}

interface User {
  id: string;
  phoneNumber: string;
}

export interface TripResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  time: string;
  tripItinerary: TripItinerary[];
  paymentInformation: PaymentInformation;
  total: number;
  encodedPolyline: string;
  user: User;
}

export interface PaymentSessionResponse {
  token: string;
  sessionId: string;
  validUntil: number;
  request: {
    txId: string;
    userId: string;
    amount: number;
    currency: string;
  };
}

class TripService extends ApiService {
  constructor() {
    super(process.env.REACT_APP_api_endpoint || '');
  }

  async getTripById(txId: string): Promise<TripResponse> {
    const response = await this.get<TripResponse>(`/v2/public/hailing/${txId}`);
    return response.data;
  }

  async createPaymentSession(txId: string): Promise<PaymentSessionResponse> {
    const response = await this.post<PaymentSessionResponse>(`/v2/public/payment-session/${txId}`);
    return response.data;
  }
}

export default new TripService();
